import React from 'react';
import { Wrench, Zap, Truck } from "lucide-react";
const IndustrySolutions = () => {
  return <section id="industry-solutions" className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-dark">Branchenspezifische Lösungen</h2>
          <p className="text-grey text-lg max-w-3xl mx-auto">
            Unsere KI-Wissensplattform passt sich perfekt an die spezifischen Anforderungen 
            Ihrer Branche an. Erfahren Sie, wie wir bereits anderen Unternehmen helfen konnten.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-10">
          {/* Maschinenbau */}
          <div className="bg-secondary rounded-xl p-8 shadow-custom">
            <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center mb-6">
              <Wrench className="text-primary" size={32} />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-dark">Maschinenbau</h3>
            <p className="text-grey mb-6">Der KI-Wissensbot kann  Recherchen in technischen Handbüchern beschleunigen und den Zugriff auf Konstruktionswissen revolutionieren.</p>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <div className="min-w-5 mt-1 text-primary">•</div>
                <span className="text-grey">Sofortiger Zugriff auf technische Zeichnungen</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="min-w-5 mt-1 text-primary">•</div>
                <span className="text-grey">Integration von CAD-Daten und Materialspezifikationen</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="min-w-5 mt-1 text-primary">•</div>
                <span className="text-grey">Beschleunigung von Engineering-Prozessen</span>
              </li>
            </ul>
          </div>
          
          {/* Energiebranche */}
          <div className="bg-secondary rounded-xl p-8 shadow-custom">
            <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center mb-6">
              <Zap className="text-primary" size={32} />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-dark">Energiebranche</h3>
            <p className="text-grey mb-6">
              Mitarbeiter im Kraftwerksbetrieb können Sicherheitsvorschriften 
              per Chat in Sekunden finden – ohne in Ordnern zu blättern oder Fachabteilungen zu konsultieren.
            </p>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <div className="min-w-5 mt-1 text-primary">•</div>
                <span className="text-grey">Sofortiger Zugriff auf Sicherheitsrichtlinien</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="min-w-5 mt-1 text-primary">•</div>
                <span className="text-grey">Integration regulatorischer Dokumentation</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="min-w-5 mt-1 text-primary">•</div>
                <span className="text-grey">Verknüpfung mit Anlagendokumentation</span>
              </li>
            </ul>
          </div>
          
          {/* Logistik */}
          <div className="bg-secondary rounded-xl p-8 shadow-custom">
            <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center mb-6">
              <Truck className="text-primary" size={32} />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-dark">Logistik</h3>
            <p className="text-grey mb-6">
              In der Logistik kann die Plattform genutzt werden, um SOPs und Zollrichtlinien via Chat abrufbar zu machen, 
              was die Schulungszeit neuer Disponenten senkt.
            </p>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <div className="min-w-5 mt-1 text-primary">•</div>
                <span className="text-grey">Automatisierte Beantwortung zu Zollvorschriften</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="min-w-5 mt-1 text-primary">•</div>
                <span className="text-grey">Integration von Routenplanungs-Know-how</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="min-w-5 mt-1 text-primary">•</div>
                <span className="text-grey">Verkürztes Onboarding für neue Mitarbeiter</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-16 text-center">
          <p className="text-grey text-lg font-medium">
            Machen Sie Ihr Unternehmenswissen jetzt nutzbar – bleiben Sie der Konkurrenz einen Schritt voraus.
          </p>
        </div>
      </div>
    </section>;
};
export default IndustrySolutions;